let loading = ''

let useLoading = {
  show(vm, params) {
    this.close()
    loading = vm.$loading(params)
  },
  close() {
    loading && loading.close()
  }
}

export default useLoading
